import { configureStore } from '@reduxjs/toolkit'

// Import each slice directly to avoid circular dependencies
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'
import gigsReducer from './slices/gigsSlice'
import applicationsReducer from './slices/applicationsSlice'
import messagesReducer from './slices/messagesSlice'
import notificationsReducer from './slices/notificationsSlice'
import likesReducer from './slices/likesSlice'
import blogReducer from './slices/blogSlice'
import faqReducer from './slices/faqSlice'
import faqCategoriesReducer from './slices/faqCategoriesSlice'
import subscriptionReducer from './slices/subscriptionSlice'
import walletReducer from './slices/walletSlice'

// Import API slices
import { statsApi } from '@/services/statsApi'
import { profileViewApi } from '@/services/profileViewApi'
import { subscriptionRtkApi } from '@/services/subscriptionRtkApi'
import { accessLimitsRtkApi } from '@/services/accessLimitsRtkApi'
import { verificationRtkApi } from '@/services/verificationRtkApi'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        ui: uiReducer,
        gigs: gigsReducer,
        applications: applicationsReducer,
        messages: messagesReducer,
        notifications: notificationsReducer,
        likes: likesReducer,
        blog: blogReducer,
        faq: faqReducer,
        faqCategories: faqCategoriesReducer,
        subscription: subscriptionReducer,
        wallet: walletReducer,
        [statsApi.reducerPath]: statsApi.reducer,
        [profileViewApi.reducerPath]: profileViewApi.reducer,
        [subscriptionRtkApi.reducerPath]: subscriptionRtkApi.reducer,
        [accessLimitsRtkApi.reducerPath]: accessLimitsRtkApi.reducer,
        [verificationRtkApi.reducerPath]: verificationRtkApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }).concat(
            statsApi.middleware,
            profileViewApi.middleware,
            subscriptionRtkApi.middleware,
            accessLimitsRtkApi.middleware,
            verificationRtkApi.middleware
        ),
    devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Set dispatch for socket service to avoid circular dependency
import { setSocketDispatch } from '@/services/socketService'
setSocketDispatch(store.dispatch)